import React from "react";

import { TimelineMarkers, TodayMarker } from "okast-timeline";

import type { JSX } from "react";

function TimelineMarker(): JSX.Element {
  return (
    <TimelineMarkers>
      <TodayMarker
        withTime
        size={2}
        style={{
          backgroundColor: "red",
          zIndex: 41,
        }}
      />
    </TimelineMarkers>
  );
}

export default TimelineMarker;
